import React, { Component } from "react";
import { connect } from "react-redux";

import { changeLang } from "./actions";
import FrIcon from "./FrIcon";
import EnIcon from "./EnIcon";
import "../common.css";
import "./Accomodation.css";

class Flags extends Component {
  changeLang = lang => () => {
    if (this.props.lang !== lang) {
      this.props.changeLang(this.props.merchantCode, lang);
    }
  };

  render() {
    return (
      <div className="flags">
        <div className="pre-flag-text">{this.props.prevText}</div>
        <div className="flag" onClick={this.changeLang("fr")}>
          {FrIcon({ greyscale: this.props.lang !== "fr" })}
        </div>
        <div className="flag" onClick={this.changeLang("en")}>
          {EnIcon({ greyscale: this.props.lang !== "en" })}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  merchantCode: state.merchant.detail.code,
  lang: state.accomodation.lang
});

const mapDispatchToProps = dispatch => ({
  changeLang: (merchantCode, lang) => {
    dispatch(changeLang(merchantCode, lang));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Flags);



// WEBPACK FOOTER //
// ./src/merchant/accomodation/Flags.js